module.exports = __webpack_public_path__ + "src/assets/2016/18.jpg";